import { memo } from 'react';
import isEqual from 'lodash.isequal';
import { useViewportSize } from 'hooks/useViewportSize';
import { GuideUseMapView } from 'views/GuideUseMap/GuideUseMap';

import { GuideUseMapContainerProps } from 'containers/GuideUseMap/GuideUseMap.interfaces';

const GuideUseMapComponent: React.FC<GuideUseMapContainerProps> = ({
  map,
  handleSetMap,
  waypointsData,
  trailsData,
  isEditorMode,
  plannedRoute,
  plannedRouteMarkersData,
  handleAddPlannedRoutePin
}) => {
  const { isMobile } = useViewportSize();
  return (
    <GuideUseMapView
      map={map}
      handleSetMap={handleSetMap}
      isMobile={isMobile}
      isEditorMode={isEditorMode}
      trailsData={trailsData}
      waypointsData={waypointsData}
      plannedRoute={plannedRoute}
      plannedRouteMarkersData={plannedRouteMarkersData}
      handleAddPlannedRoutePin={handleAddPlannedRoutePin}
    />
  );
};

export const GuideUseMap = memo(GuideUseMapComponent);
